import { render, staticRenderFns } from "./payment.vue?vue&type=template&id=2626c322"
import script from "./payment.vue?vue&type=script&lang=js"
export * from "./payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports